<template>
  <section class="dispatch-container">
    <div class="blockwrap guider" :style="guiderStyle">
      <div class="inner">
        <div class="toggler" :class="{ show: screen == 'guider' }" @click="togglerScreen">展开任务调度 <el-icon><DArrowRight /></el-icon></div>
        <div class="toggler-cover" v-if="screen == 'guider'" @click="togglerScreen" />
        <OrderList @config="orderConfigHandle" :showDog="true" wrapStyle="width: 100%" />
      </div>
    </div>

    <div class="blockwrap list" :style="listStyle">
      <div class="inner">
        <div class="toggler" :class="{ show: screen == 'list' }" @click="togglerScreen"><el-icon><DArrowLeft /></el-icon> 展开近期任务</div>
        <div class="toggler-cover" v-if="screen == 'list'" @click="togglerScreen" />
        <TaskList :forceRefresh="shouldRefreshTaskList" />
      </div>
    </div>

    <OrderConfig v-if="showOrderConfig" :data="orderConfigData" @cancel="orderConfigCancelHandle" />
    <OrderConfigNotification />
  </section>
</template>

<script setup>
  import {onMounted, ref, Transition, watch} from 'vue'
  import { DArrowRight, DArrowLeft } from '@element-plus/icons-vue'

  import OrderList from '@/pages/dispatch/components/orderlist'
  import OrderConfig from '@/pages/dispatch/components/orderconfig'
  import OrderConfigNotification from '@/pages/dispatch/components/orderconfig/notification.vue';
  import TaskList from '@/pages/dispatch/components/tasklist'

  const winWidth = window.innerWidth;

  /**
   * 切换视图
   */
  const screen = ref('guider')
  const togglerScreen = () => {
    screen.value = ({ guider: 'list', list: 'guider' })[screen.value]
  }
  const guiderStyle = ref({});
  const listStyle = ref({});
  const initLeft = () => {
    if(screen.value == 'guider') {
      guiderStyle.value = {
        left: `${-(16 + 21 + (winWidth - 40) * (0.73 - 0.27))}px`,
      }
      listStyle.value = {
        left: `${(winWidth - 40) * 0.27 - 21}px`,
        transitionDelay: '0.05s'
      }
    }
    if(screen.value == 'list') {
      guiderStyle.value = {
        left: `${16}px`,
        transitionDelay: '0.05s'
      }
      listStyle.value = {
        left: `${(winWidth - 40) * 0.73 + 16 + 21}px`,
      }
    }
  }
  onMounted(() => {
    initLeft()
  })
  watch(() => screen.value, () => {
    initLeft()
  })

  /**
   * 提交任务
   */
  const orderConfigData = ref(null)
  const showOrderConfig = ref(false)
  const orderConfigHandle = item => {
    orderConfigData.value = item;
    showOrderConfig.value = true;
  }
  const shouldRefreshTaskList = ref(false);
  let refreshTaskListTimer = null;
  const orderConfigCancelHandle = () => {
    orderConfigData.value = null;
    showOrderConfig.value = false;

    shouldRefreshTaskList.value = true;
    refreshTaskListTimer = setTimeout(() => {
      shouldRefreshTaskList.value = false;

      clearTimeout(refreshTaskListTimer)
      refreshTaskListTimer = null
    }, 1000);
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
